export function normalizeMyCoursesPayload(payload) {
  const courses = Array.isArray(payload?.courses) ? payload.courses : [];

  return {
    summary: {
      totalCourses: Number(payload?.totalCourses ?? courses.length ?? 0),
      inProgressCourses: Number(payload?.inProgressCourses ?? 0),
      completedCourses: Number(payload?.completedCourses ?? 0),
    },
    courses: courses.map((course) => {
      const studentBookingId = course?.studentBookingId ?? course?.studentBookingid ?? course?.studentBookingId ?? null;
      return {
        id: studentBookingId ?? course?.courseId ?? 0,
        title: course?.courseName ?? "",
        code: course?.courseCode ?? "",
        description: course?.courseDescription ?? "",
        image: course?.bannerImage ?? "",
        date: course?.courseDate ?? "",
        location: course?.location ?? "",
        progress: Number(course?.progressPercentage ?? 0),
        enrolmentStatus: Number(course?.enrolmentStatus ?? 1),
        enrolmentStatusName: course?.enrolmentStatusName ?? "Draft",
        status: course?.status ?? (course?.isCompleted ? "Completed" : "In Progress"),
        isCompleted: Boolean(course?.isCompleted),
        nextStep: course?.nextStep ?? "",
        buttonText: course?.buttonText ?? "Enter",
        certificateUrl: course?.certificateUrl ?? "",
        bookingNumber: course?.bookingNumber ?? "",
        courseId: course?.courseId ?? null,
        studentBookingId,
      };
    }),
  };
}
